import React from "react";
import { Link } from "react-router-dom";

const SubscribeSuccessful = () => {
    const isMobile = window.innerWidth < 768;

    return (
        <div className="ui container">
            <img
                src="../../resources/img/Fat Bastard@2x.png"
                alt=""
                style={{
                    marginTop: "120px",
                    maxWidth: 200,
                    display: "block",
                    margin: "auto",
                    position: "relative",
                }}
            />
            <center>
                <p
                    style={{
                        marginTop: "60px",
                        color: "#d6b052",
                        fontSize: "45px",
                        marginBottom: "30px",
                    }}
                >
                    Thank you for
                    {isMobile ? <br /> : " "}
                    signing up!
                </p>

                <Link
                    to="/"
                    style={{
                        color: "#434343",
                        textDecorationColor: "#434343",
                        textDecoration: "underline",
                    }}
                >
                    Return to Home Page
                </Link>
            </center>
        </div>
    );
};

export default SubscribeSuccessful;
